import { render, staticRenderFns } from "./FailedLoginContent.vue?vue&type=template&id=0ca11787&scoped=true"
import script from "./FailedLoginContent.vue?vue&type=script&lang=js"
export * from "./FailedLoginContent.vue?vue&type=script&lang=js"
import style0 from "./FailedLoginContent.vue?vue&type=style&index=0&id=0ca11787&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca11787",
  null
  
)

export default component.exports